module.exports = __webpack_public_path__ + "static/media/Multiple-Locations.3e712480.png";